import { testimonials } from '../../../mocks/testimonials';

export default function Testimonials() {
  return (
    <section id="depoimentos" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-black mb-4">O Que Nossos Clientes Dizem</h2>
          <p className="text-xl text-gray-600">Confiança comprovada por milhares de atendimentos</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-2"
            >
              {/* Quote Icon */}
              <div className="mb-6">
                <i className="ri-double-quotes-l text-5xl text-yellow-500"></i>
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500 text-xl"></i>
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-700 text-lg leading-relaxed mb-8">
                {testimonial.text}
              </p>

              {/* Client Info */}
              <div className="flex items-center gap-4 pt-6 border-t-2 border-gray-100">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover"
                />
                <div>
                  <p className="font-bold text-black text-lg">{testimonial.name}</p>
                  <p className="text-gray-600">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16">
          <div className="text-center">
            <p className="text-5xl font-bold text-yellow-500 mb-2">5000+</p>
            <p className="text-gray-600 font-medium">Atendimentos</p>
          </div>
          <div className="text-center">
            <p className="text-5xl font-bold text-yellow-500 mb-2">4.9</p>
            <p className="text-gray-600 font-medium">Avaliação Média</p>
          </div>
          <div className="text-center">
            <p className="text-5xl font-bold text-yellow-500 mb-2">10min</p>
            <p className="text-gray-600 font-medium">Tempo Médio</p>
          </div>
          <div className="text-center">
            <p className="text-5xl font-bold text-yellow-500 mb-2">24/7</p>
            <p className="text-gray-600 font-medium">Disponibilidade</p>
          </div>
        </div>
      </div>
    </section>
  );
}